"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockUpcomingTournaments = {
    success: true,
    tournaments: [
        {
            uuid: '37ee6981-7378-4020-b7a1-495f8abbdc9c',
            name: 'inProgress started late',
            status: 'inProgress',
            dateTime: new Date(new Date().getTime() - 30 * 60000).toISOString(),
            actualStartTime: new Date(new Date().getTime() - 25 * 60000).toISOString(),
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 5,
            participants: [
                {
                    nickname: 'Simba',
                    profilePicture: 'user-8',
                },
                {
                    nickname: 'Pumbaa',
                    profilePicture: 'user-6',
                },
                {
                    nickname: 'Zazu',
                    profilePicture: 'user-22',
                },
            ],
        },
        {
            uuid: '11dd1cf1-ff99-488d-a2b6-5e62bfc31cdb',
            name: 'inProgress started early',
            status: 'inProgress',
            dateTime: new Date(new Date().getTime() + 10 * 60000).toISOString(),
            actualStartTime: new Date(new Date().getTime() - 5 * 60000).toISOString(),
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: '567d1cf1-ff99-488d-a2b6-5e62bfc31cdb',
            name: 'inProgress will start soon',
            status: 'inProgress',
            dateTime: new Date(new Date().getTime() + 10 * 60000).toISOString(),
            actualStartTime: new Date(new Date().getTime() + 5 * 60000).toISOString(),
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: '74eb1403-c8f5-434c-b012-43b1fd4e9f74',
            name: 'Opened Tournament',
            status: 'opened',
            dateTime: new Date(new Date().getTime() - 5 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 3,
            participants: [
                {
                    nickname: 'Simba',
                    profilePicture: 'user-8',
                },
                {
                    nickname: 'Pumbaa',
                    profilePicture: 'user-6',
                },
                {
                    nickname: 'Zazu',
                    profilePicture: 'user-22',
                },
            ],
        },
        {
            uuid: '9c9db309-fee5-4c2f-81f0-db52b85ba6d6',
            name: 'Pending Far Future',
            status: 'pending',
            dateTime: new Date(new Date().getTime() + 7 * 24 * 60 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: '85638c92-bac1-4a17-a38e-74d73884d3a7',
            name: 'Pending Near Future',
            status: 'pending',
            dateTime: new Date(new Date().getTime() + 27 * 60 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
        {
            uuid: 'bc5e8faf-ecd7-4fc7-b899-eb9a5d4d6b6c',
            name: 'Pending Not Run',
            status: 'pending',
            dateTime: new Date(new Date().getTime() - 13 * 60 * 60000).toISOString(),
            actualStartTime: null,
            numberOfRounds: 2,
            numberOfUsers: 13,
            frameworks: ['.NET', 'Java', 'Node.JS'],
            canJoin: true,
            canManage: false,
            numJoinedUsers: 0,
        },
    ],
};
exports.default = mockUpcomingTournaments;
